// Per-environment visibility for opt-in (requires_enablement) Paradex
// products: which envs the product SELECTOR offers each in. The backend
// already hides these from the instrument list and rejects them on trade
// per env; this keeps the selector in lockstep so a product enabled in
// one env never renders in another (e.g. ZEC options must not show on
// prod).
//
// The PRODUCT_ENABLEMENT_ENVS entries below are AUTO-GENERATED by
// tools/unified-markets/products/generate.py from
// infra/helm/featureflags/flipt.yaml (FEATURE_UM_PRODUCT_ENABLEMENT). Do
// not hand-edit between the markers; edit flipt.yaml and rerun the
// generator. A code absent from the map is not gated and always shows.
const PRODUCT_ENABLEMENT_ENVS: Record<string, readonly string[]> = {
  // --- BEGIN GENERATED PRODUCT CONFIG (enablement-map) ---
  AA: ['production'],
  AC: ['test', 'production'],
  AD: ['production'],
  AE: ['production'],
  AF: ['production'],
  BA: ['production'],
  BC: ['production'],
  BG: ['production'],
  BH: ['production'],
  BI: ['production'],
  BJ: ['stage', 'test', 'production'],
  BK: ['production'],
  BL: ['production'],
  BM: ['stage', 'test', 'production'],
  BN: ['test', 'production'],
  BP: ['test', 'production'],
  BQ: ['production'],
  BR: ['production'],
  BS: ['production'],
  BT: ['production'],
  BV: ['stage', 'test', 'production'],
  BW: ['production'],
  BY: ['stage', 'test', 'production'],
  CA: ['stage', 'test', 'production'],
  CB: ['production'],
  CD: ['production'],
  CE: ['production'],
  CG: ['test', 'production'],
  CH: ['production'],
  CI: ['production'],
  XC: ['stage', 'test', 'production'],
  XD: ['stage', 'test', 'production'],
  XF: ['stage', 'test', 'production'],
  XG: ['test', 'production'],
  XH: ['test', 'production'],
  XI: ['test', 'production'],
  XJ: ['test', 'production'],
  XK: ['production'],
  XL: ['production'],
  XM: ['stage', 'test', 'production'],
  XN: ['production'],
  XO: ['production'],
  XP: ['production'],
  XQ: ['test', 'production'],
  XS: ['test', 'production'],
  XT: ['test', 'production'],
  XU: ['production'],
  XV: ['production'],
  XW: ['production'],
  XX: ['production'],
  XY: ['production'],
  XZ: ['production'],
  ZA: ['production'],
  ZB: ['production'],
  ZC: ['production'],
  ZD: ['production'],
  ZE: ['production'],
  ZF: ['production'],
  ZG: ['production'],
  ZH: ['production'],
  ZI: ['production'],
  ZJ: ['stage', 'test'],
  ZK: ['stage', 'test', 'production'],
  ZL: ['production'],
  ZM: ['production'],
  ZN: ['production'],
  ZO: ['production'],
  ZP: ['production'],
  ZQ: ['production'],
  ZR: ['production'],
  ZS: ['production'],
  ZT: ['production'],
  ZU: ['production'],
  ZV: ['production'],
  ZX: ['production'],
  ZY: ['production'],
  ZZ: ['production'],
  // --- END GENERATED PRODUCT CONFIG (enablement-map) ---
};

// Envs where the gate applies. Outside these (local dev, preview),
// everything shows so local development isn't crippled; the backend
// still hides/rejects there.
const GATED_ENVS = new Set(['stage', 'test', 'production']);

export const isProductEnabledInEnv = (code: string): boolean => {
  const envs = PRODUCT_ENABLEMENT_ENVS[code];
  if (envs == null || !GATED_ENVS.has(ENVIRONMENT)) return true;
  return envs.includes(ENVIRONMENT);
};
